import { useCallback } from "react";
import { Picker } from "@react-native-picker/picker";

import { createStyles } from "../theme";

type PickerOptions<V extends string | number> = {
  label: string;
  value: V;
};

type Props<N extends string, V extends string | number> = {
  disabled?: boolean;
  name: N;
  onChange: (name: N, value: V | null) => void;
  options: PickerOptions<V>[];
  placeholder?: string;
  value: V | null;
};

export function PickerInput<N extends string, V extends string | number>({
  disabled = false,
  name,
  onChange,
  options,
  placeholder,
  value,
}: Props<N, V>) {
  // Handlers
  const handleChange = useCallback(
    (newValue: V) => {
      onChange(name, newValue);
    },
    [onChange, name]
  );

  // Render
  return (
    <Picker
      enabled={!disabled}
      selectedValue={value ?? undefined}
      onValueChange={handleChange}
      style={[$.container, disabled && $.disabled]}
    >
      {!!placeholder && <Picker.Item label={placeholder} value={null} />}
      {options.map((option) => (
        <Picker.Item key={option.value} {...option} />
      ))}
    </Picker>
  );
}

const $ = createStyles({
  container: {
    height: 54, // TODO: Common with text-input
    px: "6",
    backgroundColor: "surface",
    borderRadius: "9999",
    fontSize: 16, // TODO: Common with text-input
    color: "onSurface",
    borderWidth: 0,
  },
  disabled: {
    opacity: 0.5,
  },
});
